import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css'; // Estilos personalizados

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleForgotPassword = async () => {
        try {
            setLoading(true);

            // Validación de formato de correo electrónico
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setMessage('Correo electrónico no válido. Por favor, ingresa un correo válido.');
                setLoading(false);
                return;
            }

            setMessage('Verificando correo electrónico...');

            // Lógica para verificar si el correo existe en tu sistema antes de enviar el código de verificación
            const response = await fetch(`/api/security/checkEmailExists?email=${email}`);
            const emailExists = await response.json();

            if (!emailExists) {
                setMessage('Correo electrónico no registrado en el sistema.');
                setLoading(false);
                return;
            }

            setMessage('Enviando código de verificación...');

            const sendVerificationResponse = await fetch('/api/security/forgotPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (sendVerificationResponse.ok) {
                const verificationCode = await sendVerificationResponse.text();
                setMessage(`Código de verificación enviado correctamente a tu correo. Revisa tu email para continuar.`);
                // Construir el enlace para redirigir a ResetPassword con el código de verificación
                const resetPasswordLink = `/reset-password?code=${verificationCode}`;
                setMessage(`Código de verificación enviado correctamente a tu correo.`);
            } else {
                const errorMessage = await sendVerificationResponse.text();
                setMessage(`Error: ${errorMessage}`);
            }

            setLoading(false);
        } catch (error) {
            setMessage('Ocurrió un error al enviar el código de verificación.');
            setLoading(false);
        }
    };

    const handleReturnToLogin = () => {
        navigate('/'); // Navegar de vuelta a la página de inicio
    };

    return (
        <div className="forgot-password-container">
            <Card className="forgot-password-card" title="Recuperar Contraseña">
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="email">Correo Electrónico</label>
                        <InputText
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={loading}
                        />
                    </div>
                    {message && <Message severity={message.includes('Error') ? 'error' : 'info'} text={message} />}
                    <Button
                        label={loading ? 'Enviando...' : 'Enviar Código'}
                        className="p-button-primary"
                        onClick={handleForgotPassword}
                        disabled={loading || !email}
                    />
                    {loading && <ProgressSpinner className="p-d-block" />}
                    <Button
                        icon="pi pi-arrow-left"
                        onClick={handleReturnToLogin}
                        className="p-button-secondary p-ml-2"
                        label="Regresar al Login"
                    />
                </div>
            </Card>
        </div>
    );
};

export default ForgotPassword;
